module.exports = __webpack_public_path__ + "media/justin_30s.3a84ac5f.mp3";